import React from 'react'

const DemoIcon = (
  <>
    <path
      d="M44.125 4.5H2.125C1.59457 4.5 1.08586 4.71071 0.710786 5.08579C0.335714 5.46086 0.125 5.96957 0.125 6.5V44.5C0.125 45.0304 0.335714 45.5391 0.710786 45.9142C1.08586 46.2893 1.59457 46.5 2.125 46.5H44.125C44.6554 46.5 45.1641 46.2893 45.5392 45.9142C45.9143 45.5391 46.125 45.0304 46.125 44.5V6.5C46.125 5.96957 45.9143 5.46086 45.5392 5.08579C45.1641 4.71071 44.6554 4.5 44.125 4.5Z"
      fill="#E6E6E6"
    />
    <path
      d="M23.1248 39.5001C23.2565 39.5002 23.3869 39.4743 23.5086 39.4238C23.6303 39.3734 23.7408 39.2994 23.8338 39.2061L31.3968 31.6161C32.4966 30.5142 33.1181 29.0232 33.1264 27.4664C33.1348 25.9095 32.5294 24.412 31.4413 23.2983C30.3533 22.1846 28.8703 21.5445 27.3137 21.5166C25.757 21.4887 24.252 22.0752 23.1248 23.1491C21.9974 22.0751 20.4923 21.4886 18.9355 21.5166C17.3787 21.5446 15.8957 22.185 14.8077 23.2988C13.7198 24.4127 13.1145 25.9104 13.1231 27.4674C13.1318 29.0244 13.7535 30.5153 14.8538 31.6171L22.4158 39.2071C22.5088 39.3002 22.6194 39.374 22.741 39.4243C22.8627 39.4746 22.9931 39.5003 23.1248 39.5001Z"
      fill="#E86C60"
    />
    <path
      d="M2.125 4.5H44.125C44.6554 4.5 45.1641 4.71071 45.5392 5.08579C45.9143 5.46086 46.125 5.96957 46.125 6.5V14.5H0.125V6.5C0.125 5.96957 0.335714 5.46086 0.710786 5.08579C1.08586 4.71071 1.59457 4.5 2.125 4.5Z"
      fill="#E86C60"
    />
    <path
      d="M37.125 9.5V1.5C37.125 1.23478 37.0196 0.98043 36.8321 0.792893C36.6446 0.605357 36.3902 0.5 36.125 0.5H34.125C33.8598 0.5 33.6054 0.605357 33.4179 0.792893C33.2304 0.98043 33.125 1.23478 33.125 1.5V9.5C33.125 9.76522 33.2304 10.0196 33.4179 10.2071C33.6054 10.3946 33.8598 10.5 34.125 10.5H36.125C36.3902 10.5 36.6446 10.3946 36.8321 10.2071C37.0196 10.0196 37.125 9.76522 37.125 9.5Z"
      fill="#444444"
    />
    <path
      d="M13.125 9.5V1.5C13.125 1.23478 13.0196 0.98043 12.8321 0.792893C12.6446 0.605357 12.3902 0.5 12.125 0.5H10.125C9.85978 0.5 9.60543 0.605357 9.41789 0.792893C9.23036 0.98043 9.125 1.23478 9.125 1.5V9.5C9.125 9.76522 9.23036 10.0196 9.41789 10.2071C9.60543 10.3946 9.85978 10.5 10.125 10.5H12.125C12.3902 10.5 12.6446 10.3946 12.8321 10.2071C13.0196 10.0196 13.125 9.76522 13.125 9.5Z"
      fill="#444444"
    />
  </>
)

export default DemoIcon
